<template>
    <CodiceFeanorView tool-module="base64url" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
